import { actionTypes as resourceActions } from 'redux-resource';
import * as types from './types';

export const checkout = (purchaseId, cardId, onComplete, message) => ({
  type: types.CHECKOUT,
  payload: {
    purchaseId,
    cardId,
    message,
    onComplete
  }
});

const checkoutDefaults = {
  resourceType: 'purchases',
  requestKey: 'checkout',
}

export const checkoutPending = (purchaseId) => ({
  ...checkoutDefaults,
  type: resourceActions.UPDATE_RESOURCES_PENDING,
  resources: [purchaseId],
});

export const checkoutSucceeded = (resp) => ({
  ...checkoutDefaults,
  type: resourceActions.UPDATE_RESOURCES_SUCCEEDED,
  resources: [resp.data],
});

export const checkoutFailed = (purchaseId) => ({
  ...checkoutDefaults,
  type: resourceActions.UPDATE_RESOURCES_FAILED,
  resources: [purchaseId],
});

export const allocationPending = () => ({
  type: types.ALLOCATION_PENDING
});

export const allocationSucceeded = () => ({
  type: types.ALLOCATION_SUCCEEDED
});

export const allocationFailed = () => ({
  type: types.ALLOCATION_FAILED
});
